import { deleteRequest, getRequest, postRequest, putRequest } from "./axios";
import { safeStringify } from "./helpers";

const { REACT_APP_API_URL } = process.env;
// const REACT_APP_API_URL = 'https://admin-api.owners.bet'
// console.log('REACT_APP_API_URL: ', REACT_APP_API_URL)

const superAdminLogin = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/login`, data);

const getAllAdmins = ({
  limit,
  pageNo,
  orderBy,
  sort,
  search,
  // superAdminId,
  adminRoleId,
  status,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin?orderBy=${orderBy}&pageNo=${pageNo}&limit=${limit}&sort=${sort}&search=${search}&status=${status}&adminRoleId=${adminRoleId}`
  );

const getAllStaff = ({ limit, pageNo, orderBy, sort, search, roleId, status }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/profile/get?orderBy=${orderBy}&pageNo=${pageNo}&limit=${limit}&sort=${sort}&search=${search}&roleId=${roleId}&status=${status}`)

const getStaffById = ({ roleId, limit, pageNo }) => {
  const params = new URLSearchParams();

  if (limit) {
    params.append("limit", limit);
  }
  if (pageNo) {
    params.append("pageNo", pageNo);
  }

  const requestUrl = `${REACT_APP_API_URL}/api/admin/profile/get-parent-profiles?roleId=${roleId}`;

  if (params.toString() !== "") {
    requestUrl.search = params.toString();
  }

  return getRequest(requestUrl.toString());
}

const getStaffDetails = ({ adminUserId }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/profile/get-admin-user?adminUserId=${adminUserId}`)

const getAllAdminGroups = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/profile/get-groups`);

const getAllCurrencies = ({ limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/currency?limit=${limit}&pageNo=${pageNo}`
  );

const getAllAffiliates = ({ limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/affiliate/all?limit=${limit}&pageNo=${pageNo}&search=${search}`
  );

const getAffiliateById = ({ affiliateId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/affiliate?affiliateId=${affiliateId}`
  );

const getAllCms = ({ pageNo, limit, search, isActive }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/cms?pageNo=${pageNo}&limit=${limit}&search=${search}&isActive=${isActive}`
  );

const getAllNotifications = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/notifications/get-all`);

const markNotificationRead = (data) =>
  postRequest(
    `${REACT_APP_API_URL}/api/admin/notifications/mark-all-as-read`,
    data
  );

const getAllPromotions = ({ pageNo, limit, search, isActive }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/banner/promotions?pageNo=${pageNo}&limit=${limit}&search=${search}&isActive=${isActive}`
  );

const deletePromotions = ({ slug, promotionId }) =>
  deleteRequest(
    `${REACT_APP_API_URL}/api/admin/banner/promotions?slug=${slug}&promotionId=${promotionId}`
  );

const getCmsByPageId = ({ cmsPageId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/cms/details?cmsPageId=${cmsPageId}`
  );

const addAvatar = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/avtar`, data);

const getAllAvatars = () => getRequest(`${REACT_APP_API_URL}/api/admin/avtar`);

const deleteAvatar = ({ key }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/avtar`, { key });

const getAllUsers = ({
  limit,
  pageNo,
  search,
  kycStatus,
  affiliateSearch,
  dobStart,
  dobEnd,
  userId,
  phoneNumber,
  orderBy,
  sortBy,
  isDeleted,
  isActive,
  promoCode
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/all?limit=${limit}&pageNo=${pageNo}&search=${search}&kycStatus=${kycStatus}&affiliateSearch=${affiliateSearch}&dobStart=${dobStart || ''}&dobEnd=${dobEnd || ""}&userId=${userId}&phoneNumber=${phoneNumber}&orderBy=${orderBy}&sort=${sortBy}&isDeleted=${isDeleted || ""}&isActive=${isActive || ""}&promoCode=${promoCode || ""
    } `
  );

const getAllCasinoProviders = ({ limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/providers?limit=${limit}&pageNo=${pageNo}&search=${search}`
  );

const getAllCasinoGames = ({
  bonusId,
  limit,
  pageNo,
  casinoCategoryId,
  search,
  isActive,
  selectedProvider,
  freespins,
  addGame,
  gameSubCategoryId,
  reorder,
  bonusFilter,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/games?limit=${limit}&pageNo=${pageNo}&casinoCategoryId=${casinoCategoryId}&search=${search}&isActive=${isActive}&providerId=${selectedProvider}&freespins=${freespins}&bonusId=${bonusId}&addGames=${addGame}&gameSubCategoryId=${gameSubCategoryId}&reorder=${reorder}&bonusFilter=${bonusFilter || ""
    }`
  );

const updateCasinoGameThumbnailURL = (data) =>
  putRequest(
    `${REACT_APP_API_URL}/api/admin/user/change-thumbnail-url`,
    data
  )

const createCurrency = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/currency`, data);

const editCurrency = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/currency`, data);

const getCurrencyById = (currencyId) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/currency/details?currencyId=${currencyId}`
  );

const getAdminRole = () => getRequest(`${REACT_APP_API_URL}/api/admin/roles`);

const getAdmin = ({ adminId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/details?adminUserId=${adminId && adminId}`
  );
const getUser = ({ userId }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/user?userId=${userId}`);

// const getAdminRoles = () =>
//   getRequest(`${REACT_APP_API_URL}/api/tenant/admin/roles`)

const getAdminUsers = (limit, pageNo, sort, roleId) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/admin?orderBy=email&limit=${limit}&pageNo=${pageNo}&sort=${sort}&adminRoleId=${roleId}`
  );

const getRefferedUsers = ({ limit, pageNo, userId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/reffered-user?limit=${limit}&pageNo=${pageNo}&userId=${userId}&status=`
  );

const getAdminUserDetails = ({ adminUserId, isTenant }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/${isTenant ? "tenant/admin/details" : "admin/tenant/admin-details"
    }?adminUserId=${adminUserId}`
  );

const createCms = ({ data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/cms`, data);

const createPromotions = ({ data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/banner/promotions`, data);

const getSuperAdminWallet = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/wallets`);

const getMasterGames = ({
  bonusId,
  limit,
  pageNo,
  search,
  casinoCategoryId,
  providerId,
  freespins,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/casino/games?limit=${limit}&pageNo=${pageNo}&search=${search}&casinoCategoryId=${casinoCategoryId}&providerId=${providerId}&freespins=${freespins}&bonusId=${bonusId}&isActive=true`
  );

const createTenantCasinoCategory = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/tenant/casino/category`, data);

const addGamesToSubCategory = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/category-games`, data);

const createTenantCasinoSubCategory = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/tenant/casino/sub-category`, data);

const updateTenantCasinoSubCategory = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/casino/sub-category`, data);

const updateSubCategoryReOrder = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/order-sub-category`, data);

const updateCategoryReOrder = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/order-category`, data);

const getTenantCasinoMenuById = ({ casinoMenuId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/casino/menu?casinoMenuId=${casinoMenuId}`
  );

const updateTenantCasinoCategory = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/casino/category`, data);

const getAllTenantCasinoMenuItems = ({ limit, pageNo, type, isActive }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/menu-items?limit=${limit}&pageNo=${pageNo}&type=${type}&isActive=${isActive}`
  );

const getCountries = ({ limit, pageNo, name, isActive, kycMethod = "" }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/country/list?limit=${limit}&pageNo=${pageNo}&name=${name}&kycMethod=${kycMethod}`
  );

const getRestrictedItems = ({ limit, pageNo, type, countryId, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/country/restricted-items?limit=${limit}&pageNo=${pageNo}&type=${type}&countryId=${countryId}&search=${search}`
  );

const getUnRestrictedItems = ({ limit, pageNo, type, countryId, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/country/unrestricted-items?limit=${limit}&pageNo=${pageNo}&type=${type}&countryId=${countryId}&search=${search}`
  );

const addRestrictedItems = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/country/restricted`, data);

const updateSuperAdminUser = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/`, data);

const createSuperAdminUser = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/`, data);

const createStaff = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/profile/create`, data)

const updateStaff = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/profile/update`, data)

const deleteStaff = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/profile/delete-admin-profile`, data)

const updateStaffStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/profile/update-profile-status`, data)

const createCasinoGame = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/games`, data);

const createCasinoProvider = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/provider`, data);

const createCasinoCategory = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/category`, data);

const createCasinoSubCategory = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/sub-category`, data);

const updateCasinoGame = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/game`, data);

const updateCasinoCategory = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/category`, data);

const updateCasinoSubCategory = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/sub-category`, data);

const updateCasinoProvider = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/provider`, data);

const getSuperAdminDetails = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/details`);

const createTenantCasinoMenuItem = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/tenant/menu-item`, data);

const getAllWageringCasinoGames = ({ providerId, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/all-games?providerId=${providerId}&search=${search}`
  );

const updateTenantCasinoMenuItem = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/menu-item`, data);

const updateTenantAdmin = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/tenant/admin`, data);

const getAllSuperAdminTransactions = ({
  limit,
  pageNo,
  search,
  startDate,
  endDate,
  currencyId,
  transactionType,
  paymentProvider,
  isUserDetail,
  userId,
  status,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/transactions?limit=${limit}&pageNo=${pageNo}&actioneeType=${search}&status=${status}&startDate=${startDate || ""}&endDate=${endDate || ""}&currencyCode=${currencyId}&transactionType=${transactionType}&paymentProvider=${paymentProvider}${isUserDetail ? `&userId=${userId}` : ""
    }`
  );

const getBankingTransactions = ({
  limit,
  pageNo,
  searchString,
  startDate,
  endDate,
  status,
  paymentMethod,
  transactionType,
}) => {
  const requestUrl = new URL(
    `${REACT_APP_API_URL}/api/admin/payments/transactions`
  );
  const params = new URLSearchParams();

  if (transactionType) params.append("transactionType", transactionType);
  if (limit) params.append("limit", limit);
  if (pageNo) params.append("page", pageNo);
  if (searchString) params.append("search", searchString);
  if (startDate) params.append("startDate", startDate);
  if (endDate) params.append("endDate", endDate);
  if (status) params.append("status", status);
  if (paymentMethod) params.append("paymentMethod", paymentMethod);

  requestUrl.search = params.toString();

  return getRequest(requestUrl.toString());
};

const updateTransactionStatus = (data) =>
  postRequest(
    `${REACT_APP_API_URL}/api/admin/payments/update-transaction-status`,
    data
  );

const updateCryptoTransactionStatus = (data) =>
  postRequest(
    `${REACT_APP_API_URL}/api/admin/payments/hero-payment-status`,
    data
  );

const getSuperAdminTransactionUsers = ({ email }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/transaction-users?email=${email}`);

const getSuperAdminAggregators = ({ limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/aggregators?limit=${limit}&pageNo=${pageNo}`
  );

const createSuperAdminAggregator = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/aggregator`, data);

// const getSuperAdminGameCategory = ({ limit, pageNo, search, isActive , categoryType}) =>
//   getRequest(
//     `${REACT_APP_API_URL}/api/admin/casino/categories?limit=${limit}&pageNo=${pageNo}&categoryType=${categoryType ||""}&search=${search}${isActive ? `&status=${isActive}` : ""
//     }`
//   );

const getSuperAdminGameCategory = ({ limit, pageNo, search, isActive, categoryType, status }) => {
  const params = new URLSearchParams();

  if (limit) params.append("limit", limit);
  if (pageNo) params.append("pageNo", pageNo);
  if (search) params.append("search", search);
  if (status) params.append("status", status)
  if (typeof isActive !== "undefined" && isActive !== null) params.append("isActive", isActive);
  if (categoryType) params.append("categoryType", categoryType);

  const queryString = params.toString();
  const url = `${REACT_APP_API_URL}/api/admin/casino/categories${queryString ? `?${queryString}` : ""}`;

  return getRequest(url);
};



const getSuperAdminGameSubCategory = ({
  limit,
  pageNo,
  search,
  gameCategoryId,
  isActive,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/sub-category?pageNo=${pageNo}&gameCategoryId=${gameCategoryId}&search=${search}&limit=${limit}&isActive=${isActive}`
  );

const getSuperAdminPopularGame = ({ limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/popular?pageNo=${pageNo}&limit=${limit}&search=${search || ""}`
  );

const getSuperAdminNewGame = ({ limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/new-games?pageNo=${pageNo}&limit=${limit}&search=${search || ""}`
  );

const handlePopularGame = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/popular`, data);

const deleteRestrictedItems = (data) =>
  deleteRequest(
    `${REACT_APP_API_URL}/api/admin/country/restricted-items`,
    data
  );

const getRestrictedCountries = ({ itemId, type, limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/country/restricted?itemId=${itemId}&type=${type}&limit=${limit}&pageNo=${pageNo}`
  );

const getUnRestrictedCountries = ({ itemId, type, limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/country/unrestricted?itemId=${itemId}&type=${type}&limit=${limit}&pageNo=${pageNo}&search=${search}`
  );

const deleteRestrictedCountries = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/country/restricted`, data);

const addRestrictedCountries = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/country/restricted-items`, data);

const addDepositToOther = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/add-balance`, data);

const getSuperAdminCasinoTransactions = ({
  limit,
  pageNo,
  startDate,
  endDate,
  currencyCode,
  transactionType,
  tenantId,
  status,
  email,
  adminId,
  userId,
  gameIdentifier
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/transactions?limit=${limit}&pageNo=${pageNo}&startDate=${startDate || ""}&endDate=${endDate || ""}&currencyCode=${currencyCode}&transactionType=${transactionType}&tenantId=${tenantId}&status=${status}&email=${email}&adminId=${adminId}&userId=${userId}&gameIdentifier=${gameIdentifier || ""}`
  );


const getSuperAdminSportsBookTransactions = ({
  limit,
  pageNo,
  startDate,
  endDate,
  transactionType,
  status,
  email,
  adminId,
  betslipStatus,
  eventSearch,
  userId,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/sportsbook/transactions?limit=${limit}&pageNo=${pageNo}&startDate=${startDate || ""}&endDate=${endDate || ""}&transactionType=${transactionType}&status=${status}&email=${email}&adminId=${adminId}&betslipStatus=${betslipStatus}&eventSearch=${eventSearch}${userId ? `&userId=${userId}` : ""}`
  );

const getSuperAdminSportsTransactions = ({
  limit,
  pageNo,
  startDate,
  endDate,
  currencyCode,
  transactionType,
  tenantId,
  status,
  email,
  adminId,
  userId,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/sports-transactions?limit=${limit}&pageNo=${pageNo}&startDate=${startDate}&endDate=${endDate}&currencyCode=${currencyCode}&transactionType=${status}&actionType=${transactionType}&email=${email}&userId=${userId}`
  );

const getAllClients = ({ orderBy, limit, pageNo, sort, search, status }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/tenant/admin-users?orderBy=${orderBy}&limit=${limit}&pageNo=${pageNo}&sort=${sort}&search=${search}&status=${status}`
  );

const getAllPortals = ({ adminId }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/tenant/list?adminId=${adminId}`);

const getTenantList = () => getRequest(`${REACT_APP_API_URL}/api/tenant/list`);

const updateSuperAdminCMS = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/cms`, data);

const updatePromotions = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/banner/promotions`, data);

const isDomainExist = ({ domain, tenantId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/check-domain?domain=${domain}&tenantId=${tenantId}`
  );

const tenantViewToggleStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/admin/status`, data);

const superAdminViewToggleStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/status`, data);

const deleteTenantAdminCategory = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/casino/category`, data);

const deleteTenantAdminCasinoGames = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/casino/games`, data);

const deleteTenantAdminCasinoProvider = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/casino/provider`, data);

const deleteTenantAdminSubCategory = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/casino/sub-category`, data);



const getAllWithdrawRequestAdmin = ({
  name,
  status,
  page,
  limit,
  startDate,
  endDate,
  paymentProvider,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/user/all-withdraw-request?search=${name}&status=${status}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&paymentProvider=${paymentProvider}`
  );

const getAllWithdrawRequestSuperAdmin = ({
  name,
  status,
  page,
  limit,
  startDate,
  endDate,
  tenantId,
  adminId,
  paymentProvider,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/all-withdraw-request?search=${name}&status=${status}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&adminId=${adminId}&tenantId=${tenantId}&paymentProvider=${paymentProvider}`
  );
const getAllSAProviders = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/casino/providers`);

const getAllTAProviders = () =>
  getRequest(`${REACT_APP_API_URL}/api/casino/providers`);

const depositCasino = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/casino/bonus`, data);

const getGlobalRegistration = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/global-registration`);

const updateGlobalRegistration = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/global-registration`, data);

const getSAConvertAmount = ({ currencyFields, currencyCode, tenantIds }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/bonus/convert-amount?currencyFields=${safeStringify(
      currencyFields
    )}&currentCurrencyCode=${currencyCode}&tenantIds=${tenantIds}`
  );

const getAllBonus = ({
  adminId,
  tenantId,
  limit,
  pageNo,
  bonusType,
  isActive,
  search,
  userId,
  reorder,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/bonus?adminId=${adminId}&tenantId=${tenantId}&limit=${limit}&pageNo=${pageNo}&search=${search}&isActive=${isActive}&bonusType=${bonusType}&userId=${userId}&reorder=${reorder}`
  );

const createBonus = (data, isTenant) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/bonus`, data);

const updateBonus = (data, isTenant) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/bonus`, data);

const getBonus = ({ bonusId, isTenant, userBonusId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/bonus/detail?bonusId=${bonusId}&userBonusId=${userBonusId}`
  );

const issueBonus = ({ data, isTenant }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/bonus/issue`, data);

const getUserBonus = ({ limit, pageNo, bonusType, status, userId, isTenant }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/bonus/user?limit=${limit}&pageNo=${pageNo}&bonusType=${bonusType}&status=${status}&userId=${userId}`
  );

const cancelBonus = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/bonus/cancel`, data);

const getUserDocument = (userId) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/user/document?userId=${userId}`);

const verifyUserDocument = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/verify-document`, data);

const getDocumentLabel = (userId) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/document-label?userId=${userId}`);

const getDemographicDetailsSuperAdmin = ({ endDate, startDate, dateOptions }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/report/demographic?startDate=${startDate}&endDate=${endDate}&dateOptions=${dateOptions}`
  );

const updateDocumentLabel = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/document-label`, data);

const createDocumentLabel = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/document-label`, data);

const requestDocument = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/request-document`, data);

const cancelDocumentRequest = (data) =>
  putRequest(
    `${REACT_APP_API_URL}/api/admin/user/cancel-document-request`,
    data
  );

const getTenantPlayerManagement = ({
  endDate,
  startDate,
  limit,
  dateOptions,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/report/top-players?startDate=${startDate}&endDate=${endDate}&limit=${limit}&dateOptions=${dateOptions}`
  );

const getSuperAdminPlayerManagement = ({
  endDate,
  startDate,
  limit,
  dateOptions,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/report/top-players?startDate=${startDate}&endDate=${endDate}&limit=${limit}&dateOptions=${dateOptions}`
  );

const getPaymentMethod = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/bonus/payment-methods`);

const getWageringTemplateDetail = ({ wageringTemplateId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/wagering-template/details?wageringTemplateId=${wageringTemplateId}`
  );

const getSuperAdminLivePlayerReport = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/report/live-player`);

const getSuperAdminAllWageringTemplate = ({ adminId }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/wagering-template/all`);

const getSuperAdminWageringTemplateDetail = ({
  wageringTemplateId,
  limit,
  pageNo,
  providerId,
  search,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/wagering-template/details?wageringTemplateId=${wageringTemplateId}&pageNo=${pageNo}&limit=${limit}&providerId=${providerId}&search=${search}`
  );

const createWageringTemplate = (isTenant, data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/wagering-template`, data);

const updateWageringTemplate = (isTenant, data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/wagering-template`, data);
const getBalanceBonuses = ({ tenantId }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/bonus/balance`);

const getSuperAdminWageringTemplate = ({ search, limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/wagering-template?adminId=pageNo=${pageNo}&limit=${limit}&search=${search}`
  );

const getTenantWageringTemplate = ({ search, limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/tenant/wagering-template?pageNo=${pageNo}&limit=${limit}&search=${search}`
  );

const getSAPlayerLiability = ({ startDate, endDate, dateOptions }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/report/players-liability?startDate=${startDate}&endDate=${endDate}&dateOptions=${dateOptions}`
  );

const getSAKPISummary = ({
  startDate,
  endDate,
  search,
  dateOptions,
  page,
  limit,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/bonus-report?search=${search}&date=${dateOptions}&pageNo=${page}&limit=${limit}`
  );

const getUserStats = ({ startDate, endDate, filter, page, limit, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/user-stats?filter=${filter}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&search=${search}`
  );

const getSAKPIReport = ({
  startDate,
  endDate,
  dateOptions,
  selectedTab,
  search,
  page,
  limit,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/host-player-reports?search=${search}&date=${dateOptions}&pageNo=${page}&limit=${limit}`
  );

const getSAGameReport = ({
  startDate,
  endDate,
  dateOptions,
  selectedTab,
  search,
  page,
  limit,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/fetch-game-reports?search=${search}&date=${dateOptions}&pageNo=${page}&limit=${limit}`
  );

const getPlayerGameReport = ({
  startDate,
  endDate,
  dateOptions,
  selectedTab,
  search,
  page,
  limit,
  hostSearch,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/player-reports?search=${search}&date=${dateOptions}&pageNo=${page}&limit=${limit}&hostSearch=${hostSearch}`
  );

const getSAPlayerGameReport = ({
  userId,
  limit,
  startDate,
  endDate,
  dateOptions,
  selectedTab,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/report/game?userId=${userId}&limit=${limit}&customStartDate=${startDate}&customEndDate=${endDate}&dateOptions=${dateOptions}&tab=${selectedTab}`
  );

const getFreeSpinGames = ({
  providerId,
  bonusId,
  limit,
  pageNo,
  search,
  isTenant,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/freespin-games?providerId=${providerId}&bonusId=${bonusId}&limit=${limit}&pageNo=${pageNo}&search=${search}`
  );

const getEmailTemplates = ({ isTenant }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/email/all`);

const getEmailTemplate = ({ emailTemplateId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/email?emailTemplateId=${emailTemplateId}`
  );

const updateEmailTemplate = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/email`, data);

const getDynamicKeys = ({ isTenant, type }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/email/dynamic-data?type=${type}`);

const createEmailTemplate = ({ data, isTenant }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/email`, data);

const primaryEmailTemplate = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/email/mark-primary`, data);

const deleteEmailTemplate = ({ data, isTenant }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/email `, data);

const getloyaltyLevel = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/bonus/loyalty-level`);

const updateloyaltyLevel = ({ isTenant, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/bonus/loyalty-level`, data);

const updateWelcomeBonus = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/welcome-bonus`, data);

const updateLoyaltyPoint = ({ loyaltyPoint }) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/loyalty-point`, loyaltyPoint);

const updateLoyaltyLimit = ({ loyaltyLimit }) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/limit`, loyaltyLimit);

const getLanguages = ({ limit, pageNo, name }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/language?limit=${limit}&pageNo=${pageNo}&name=${name}`
  );

const updateProfile = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/profile`, data);

const updateSiteConfiguration = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/site-information`, data);

const getSiteConfiguration = (data) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/site-information`, data);

const getAdminConfiguration = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/get-admin-configs`);

const createAdminConfiguration = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/configs`, data);

const updateAdminConfiguration = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/configs`, data);

const getAdminChildren = ({ superAdminId, superRoleId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/childs?adminId=${superAdminId}&adminRoleId=${superRoleId}`
  );

const getAllGroups = (isTenant) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/all-group`);

const getTags = () => getRequest(`${REACT_APP_API_URL}/api/tenant/user/tags`);

const updateTags = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/tags`, data);

const getImageGallery = (isTenant) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/gallery`);

const deleteFromGallery = ({ isTenant, data }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/gallery`, data);

const getDuplicateUsers = ({ limit, pageNo, userId, isTenant }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/duplicate?limit=${limit}&pageNo=${pageNo}&userId=${userId}`
  );

const testEmailTemplateEndPoint = ({ data, isTenant }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/email/test`, data);

const setDailyLimit = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/daily-limit`, data);

const setDepositLimit = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/deposit-limit`, data);

const setLossLimit = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/loss-limit`, data);

const getOwnerPermissions = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/tenant/owner-permission`);

const setEmailCreds = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/email/credentials`, data);

const disableUser = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/disable-until`, data);

const setSessionLimit = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/session-time`, data);

const getCMSDynamicKeys = ({ isTenant }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/cms/dynamic-data`);

const getAllSABanners = ({ limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/banner?limit=${limit}&pageNo=${pageNo}`
  );

const getBankingDetails = ({ limit, pageNo, bankType }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/bank/get-details?limit=${limit}&pageNo=${pageNo}&bankType=${bankType}`
  );

const getAllTransactionDrivers = ({ limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/transaction-agents/list?limit=${limit}&page=${pageNo}`
  );

const getTransactionDriversList = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/transaction-agents/list-agents`);

const createOrUpdateTransactionDriver = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/transaction-agents/update`, data);

const createBankingDetails = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/bank/store-details`, data);

const updateBankingDetails = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/bank/store-details`, data);

const updateBankingDetailsStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/bank/update-status`, data);

const deleteBankingDetails = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/bank/remove-bank`, data);

const getAffiliateRequests = ({ limit, pageNo, isAffiliateUpdated }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/document?isAffiliateUpdated=${isAffiliateUpdated}&userId=&limit=${limit}&pageNo=${pageNo}`
  );

const getWelcomeBonus = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/welcome-bonus`);

const deleteSABanners = ({ name }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/banner?pageBannerId=${name}`);

const uploadSABanner = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/banner`, data);

const updateSABanner = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/banner`, data);

const updateAffiliateStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/verify-document`, data);

const deleteEmailTemplateLanguage = ({ isTenant, data }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/email/language`, data);

const getEmailTypes = ({ isTenant }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/email/dynamic-data`);

const deleteCMSLanguage = ({ isTenant, data }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/cms`, data);

const updateReorderGames = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/casino/order-casino-games`, data);

const addInternalTag = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/internal`, data);

const getLanguageSupportKeys = ({ tenantId, language, isTenant }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/language/support-keys?language=${language}`
  );

const uploadLanguageCSV = ({ data, isTenant }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/language/load-file`, data);

const updateLanguageSupport = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/language/support-keys`, data);

const getCMSLanguage = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/cms/language`);

const getElasticHealth = (isTenant) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/report/elastic-health-check`);

const sendMail = ({ email, isSuperAdmin }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/forget-password`, { email });

const resetPassword = ({ isSuperAdmin, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/verify-forget-password`, data);

const updateUserAffiliate = ({ isSuperAdmin, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/affiliate/user`, data);

const addUserAffiliate = ({ isSuperAdmin, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/affiliate/add-user`, data);

const getPaymentAggregators = (isTenant) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/payment/aggregators`);

const getPaymentProvider = ({
  isTenant,
  paymentType,
  aggregator,
  tenant,
  group,
  status,
  tenantIds,
  category,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/payment/providers?paymentType=${paymentType}&aggregator=${aggregator}&tenant=${tenant}&group=${group}&status=${status}&tenantIds=${tenantIds}&category=${category}`
  );

const getProviderDetails = ({ providerId, isTenant }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/payment/provider-details?providerId=${providerId}`
  );

const configProviderSettings = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/payment/provider-settings`, data);

const updateKycMethod = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/country/kyc-method`, data);

const updatePaymentProviderStatus = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/update-provider-status`, data);

const reOrderPaymentProviders = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/tenant/payment/order-providers`, data);

const getCommentsList = ({
  limit,
  search,
  pageNo,
  userId,
  isTenant,
  role,
  status,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/comments?limit=${limit}&pageNo=${pageNo}&search=${search}&userId=${userId}&role=${role}&status=${status}`
  );

const addComments = ({ isTenant, data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/user/comment`, data);

const updateSAUserStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/status`, data);

const sendEmailTemplate = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/email/send-multiple-email`, data);

const updateComment = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/comment-status`, data);
const reorderBonus = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/bonus/order`, data);

const getSegments = ({ isTenant }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/bonus/segments`);

const deleteBonus = ({ isTenant, data }) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/bonus`, data);

const verifyPlayerEmail = ({ isTenant, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/verify-email`, data);

const verifyOrMarkSuspiciousUser = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/verify-user`, data);

const getAllReviews = ({ limit, search, pageNo, status }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/review?limit=${limit}&pageNo=${pageNo}&search=${search}&status=${status}`
  );

const addReview = ({ data }) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/review`, data);

const updateReview = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/review`, data);

const resetProfilePassword = ({ isTenant, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/change-password`, data);

const resetPasswordEmail = ({ data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/reset-password`, data);

const resetUserPassword = ({ isTenant, data }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/update-password`, data);

const getPaymentCategories = ({ paymentType }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/payment/category?paymentType=${paymentType}`
  );

const orderPaymentCategories = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/payment/order-category`, data);

const updateUser = ({ data, isTenant }) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user`, data);

const getCashbackData = ({ isTenant, userId, level, currencyCode }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/user/cashback?userId=${userId}&level=${level}&currencyCode=${currencyCode}`
  );

const getBetSettings = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/sportsbook/bet-settings`);

const updateBetSettings = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/sportsbook/bet-settings`, data);

const addBetSettings = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/sportsbook/bet-settings`, data);

const getSportsList = ({ limit, pageNo, isAllListing = false }) => {
  return isAllListing
    ? getRequest(
      `${REACT_APP_API_URL}/api/admin/sportsbook/sport?limit=${limit}&pageNo=${pageNo}&listing=all`
    )
    : getRequest(
      `${REACT_APP_API_URL}/api/admin/sportsbook/sport?limit=${limit}&pageNo=${pageNo}`
    );
};

const getCountriesList = ({ limit, pageNo, search }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/sportsbook/countries?search=${search}&limit=${limit}&pageNo=${pageNo}`
  );

const getMatchesList = ({ limit, pageNo, isLive, eventStatus }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/sportsbook/matches?limit=${limit}&pageNo=${pageNo}&isLive=${isLive}&eventStatus=${eventStatus}`
  );

const getMarketsList = ({ limit, pageNo, isLive, providerSportId }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/sportsbook/markets?limit=${limit}&pageNo=${pageNo}&isLive=${isLive}&providerSportId=${providerSportId}`
  );

const getTournamentsList = ({
  limit,
  pageNo,
  providerCountryId,
  providerSportId,
}) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/sportsbook/tournaments?limit=${limit}&pageNo=${pageNo}&providerCountryId=${providerCountryId}&providerSportId=${providerSportId}`
  );

const updateStatus = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/status`, data);

const bonusAdd = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/global-bonus`, data);

const fetchRollOverBonus = (data) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/global-bonus`);

const verifyStaffCode = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/profile-code-verify`, data);

// Add these functions to your existing apiCalls.js file

// Promo Codes API calls
const getAllPromoCodes = ({ limit, pageNo }) =>
  getRequest(`${REACT_APP_API_URL}/api/admin/promocode/get-all?limit=${limit}&pageNo=${pageNo}`);

const getActivePromoCodes = () =>
  getRequest(`${REACT_APP_API_URL}/api/admin/promocode/get-all?status=true`)

const sendUserPromoCode = (data) =>
  putRequest(`${REACT_APP_API_URL}/api/admin/user/promocode`, data);

const createOrUpdatePromoCode = (data) => {
  if (data.promocodesId) {
    // Update existing promo code
    return putRequest(`${REACT_APP_API_URL}/api/admin/promocode/update`, data);
  } else {
    // Create new promo code
    return postRequest(`${REACT_APP_API_URL}/api/admin/promocode/create`, data);
  }
};

const deletePromoCode = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/promocode/delete`, data);

// Voucher Codes API calls
const getAllVoucherCodes = ({ limit, pageNo, search, status }) => {
  const params = new URLSearchParams();

  if (pageNo) params.append("pageNo", pageNo);
  if (limit) params.append("limit", limit);
  if (search) params.append("search", search);
  if (status !== undefined && status !== null && status !== "") params.append("status", status);

  const queryString = params.toString();
  const url = `${REACT_APP_API_URL}/api/admin/voucher-codes/get-all${queryString ? `?${queryString}` : ""}`;

  return getRequest(url);
};

const createVoucherCode = (data) => {
  // Build the request body, only including code if it has a value
  const body = {
    amountUsd: data.amountUsd,
    expiresAt: data.expiresAt,
  };

  // Include status if provided (e.g., "active" / "inactive")
  if (typeof data.status !== "undefined" && data.status !== null) {
    body.status = data.status;
  }

  // Only add code if it's provided and not empty
  if (data.code && data.code.trim() !== "") {
    body.code = data.code;
  }

  // Only add notes if provided
  if (data.notes && data.notes.trim() !== "") {
    body.notes = data.notes;
  }

  return postRequest(`${REACT_APP_API_URL}/api/admin/voucher-codes/create`, body);
};

const updateVoucherCode = (data) => {
  const body = {
    voucherCodeId: data.voucherCodeId,
  };

  // Only add fields that are provided
  if (data.status !== undefined) {
    body.status = data.status;
  }

  if (data.isRedeemed !== undefined) {
    body.isRedeemed = data.isRedeemed;
  }

  if (data.expiresAt) {
    body.expiresAt = data.expiresAt;
  }

  if (data.notes !== undefined) {
    body.notes = data.notes;
  }

  if (data.code && data.code.trim() !== "") {
    body.code = data.code;
  }

  if (data.amountUsd !== undefined) {
    body.amountUsd = data.amountUsd;
  }

  return putRequest(`${REACT_APP_API_URL}/api/admin/voucher-codes/update`, body);
};

const deleteVoucherCode = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/voucher-codes/delete`, data);

const deleteCagegoryGame = (data) => {
const { gameCategoryId, casinoGameId } = data;
  const params = new URLSearchParams();
  if (gameCategoryId) params.append("gameCategoryId", gameCategoryId);
  if (casinoGameId) params.append("casinoGameId", casinoGameId);

  const queryString = params.toString();
  const url = `${REACT_APP_API_URL}/api/admin/casino/delete-category-game${queryString ? `?${queryString}` : ""}`;
  return deleteRequest(url, data);


};



const deleteCMS = (data) =>
  deleteRequest(
    `${REACT_APP_API_URL}/api/admin/cms`, data
  );


const deleteUser = (data) =>
  deleteRequest(
    `${REACT_APP_API_URL}/api/admin/user/delete-user`, data
  );


const restoreUser = (data) =>
  putRequest(
    `${REACT_APP_API_URL}/api/admin/user/restore-user`, data
  )


const deleteCasinoCategory = (data) =>
  deleteRequest(`${REACT_APP_API_URL}/api/admin/casino/category`, data);

const deleteTransactionDriver = (data) =>
  postRequest(`${REACT_APP_API_URL}/api/admin/transaction-agents/delete`, data);

const getAllApks = ({ limit, pageNo }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/android-apk?limit=${limit}&page=${pageNo}`
  );

const updateAllApks = (data) =>
  postRequest(
    `${REACT_APP_API_URL}/api/admin/android-apk`, data
  );

const addCasinoGameCategory = (data) =>
  postRequest(
    `${REACT_APP_API_URL}/api/admin/casino/add-featured-game`, data
  );


const getCategoryGames = ({ limit, pageNo, gameCategoryId }) => {
  const params = new URLSearchParams();

  if (limit) params.append("limit", limit);
  if (pageNo) params.append("pageNo", pageNo);

  if (gameCategoryId) params.append("gameCategoryId", gameCategoryId);

  const queryString = params.toString();
  const url = `${REACT_APP_API_URL}/api/admin/casino/get-category-game${queryString ? `?${queryString}` : ""}`;

  return getRequest(url);
};


const getCategoryGamesCount = ({ id }) =>
  getRequest(
    `${REACT_APP_API_URL}/api/admin/casino/count-featured-games?gameCategoryId=${id}`
  );





export {
  fetchRollOverBonus,
  bonusAdd,
  addReview,
  getAllReviews,
  updateReview,
  superAdminLogin,
  updatePromotions,
  // tenantLogin,
  // getAllTenants,
  getAllAdmins,
  // createTenant,
  // getThemeData,
  // getAllThemes,
  getAllCurrencies,
  // getAllTenantAffiliates,
  // getAllTenantAdmins,
  // getAllTenantCMS,
  createCurrency,
  editCurrency,
  getAllAffiliates,
  getAllCms,
  getAllUsers,
  getAllAvatars,
  addAvatar,
  deleteAvatar,
  // createTenantAdmin,
  // getTenant,
  // editTenant,
  getAdminRole,
  getAdmin,
  getCurrencyById,
  getUser,
  deletePromotions,
  // getAllCredKeys,
  // updateTheme,
  // createTheme,
  // getAllCredentials,
  // createCredentials,
  // getAllCreds,
  // getCredByKey,
  // updateCreds,
  // getTenantDetails,
  // getAllTenantUsers,
  // createTenantCredentials,
  // getTenantUserDetails,
  // getUserFields,
  // updateUserFields,
  // updateTenantCredentials,
  // getAdminRoles,
  getAdminUsers,
  getAdminUserDetails,
  // createAdminUser,
  // createTenantUser,
  // updateTenantUser,
  // getAllThemesTenant,
  // updateThemeTenant,
  // getTenantAffiliateById,
  // updateTenantAffiliate,
  createCms,
  // getCmsDetails,
  // updateCms,
  // getTenantRole,
  // getTenantAdminRole,
  // getTenantWallet,
  getSuperAdminWallet,
  getAffiliateById,
  getCmsByPageId,
  // getTenantCasinoCategories,
  // getTenantCasinoSubCategories,
  createTenantCasinoCategory,
  getTenantCasinoMenuById,
  updateTenantCasinoCategory,
  getAllCasinoProviders,
  getAllCasinoGames,
  getCountries,
  createSuperAdminUser,
  updateSuperAdminUser,
  getAllTenantCasinoMenuItems,
  getSuperAdminDetails,
  createCasinoGame,
  createCasinoProvider,
  updateCasinoGame,
  updateCasinoProvider,
  createTenantCasinoMenuItem,
  getAllWageringCasinoGames,
  // getAllTenantCasinoTables,
  updateTenantCasinoMenuItem,
  // updateTenantAdminUser,
  updateTenantAdmin,
  getAllSuperAdminTransactions,
  // getAllTenantTransactions,
  // getAllTenantCasinoTransactions,
  // getTenantTransactionUsers,
  getSuperAdminTransactionUsers,
  // getTenantCountries,
  getSuperAdminAggregators,
  createSuperAdminAggregator,
  getSuperAdminGameCategory,
  getSuperAdminGameSubCategory,
  getSuperAdminPopularGame,
  getSuperAdminNewGame,
  handlePopularGame,
  createTenantCasinoSubCategory,
  updateTenantCasinoSubCategory,
  // getTenantGames,
  getMasterGames,
  addGamesToSubCategory,
  // deleteTenantCasinoGame,
  // updateTenantCategoryGame,
  updateSubCategoryReOrder,
  updateCategoryReOrder,
  getRestrictedItems,
  getUnRestrictedItems,
  addRestrictedItems,
  deleteRestrictedItems,
  getRestrictedCountries,
  getUnRestrictedCountries,
  deleteRestrictedCountries,
  addRestrictedCountries,
  // getAllTenantCurrencies,
  addDepositToOther,
  getSuperAdminCasinoTransactions,
  getSuperAdminSportsBookTransactions,
  getAllClients,
  getAllPortals,
  getTenantList,
  isDomainExist,
  updateSuperAdminCMS,
  superAdminViewToggleStatus,
  tenantViewToggleStatus,
  deleteTenantAdminCategory,
  deleteTenantAdminSubCategory,
  getAllWithdrawRequestAdmin,
  getAllWithdrawRequestSuperAdmin,
  getAllSAProviders,
  getAllTAProviders,
  getGlobalRegistration,
  updateGlobalRegistration,
  getSAConvertAmount,
  getAllBonus,
  createBonus,
  updateBonus,
  getBonus,
  issueBonus,
  getUserBonus,
  cancelBonus,
  getUserDocument,
  verifyUserDocument,
  getDocumentLabel,
  updateDocumentLabel,
  // getDemographicDetailsTenant,
  getDemographicDetailsSuperAdmin,
  createDocumentLabel,
  requestDocument,
  cancelDocumentRequest,
  getPaymentMethod,
  getWageringTemplateDetail,
  getSuperAdminPlayerManagement,
  getTenantPlayerManagement,
  getSuperAdminLivePlayerReport,
  // getTenantLivePlayerReport,
  getSuperAdminAllWageringTemplate,
  // getTenantAllWageringTemplate,
  getSuperAdminWageringTemplateDetail,
  createWageringTemplate,
  updateWageringTemplate,
  getBalanceBonuses,
  // getTAConvertAmount,
  // getAllTABonus,
  // getTAWageringTemplateDetail,
  getSuperAdminWageringTemplate,
  getTenantWageringTemplate,
  // getTenantWageringTemplateDetail,
  // getTABalanceBonuses,
  getSAPlayerLiability,
  // getTAPlayerLiability,
  getSAKPISummary,
  // getTAKPISummary,
  getSAKPIReport,
  // getTAKPIReport,
  getSAGameReport,
  // getTAGameReport,
  getSAPlayerGameReport,
  // getTAPlayerGameReport,
  getFreeSpinGames,
  // getTenantOwnerDetails,
  getloyaltyLevel,
  updateloyaltyLevel,
  getLanguages,
  getEmailTemplates,
  getEmailTemplate,
  primaryEmailTemplate,
  updateEmailTemplate,
  createEmailTemplate,
  updateLoyaltyPoint,
  updateLoyaltyLimit,
  getDynamicKeys,
  getAdminChildren,
  updateProfile,
  // updateAdminProfile,
  getAllGroups,
  getTags,
  updateTags,
  getImageGallery,
  deleteFromGallery,
  getDuplicateUsers,
  testEmailTemplateEndPoint,
  setDailyLimit,
  setDepositLimit,
  setLossLimit,
  getOwnerPermissions,
  setEmailCreds,
  disableUser,
  setSessionLimit,
  // getBanners,
  // uploadBanner,
  getCMSDynamicKeys,
  deleteEmailTemplateLanguage,
  getEmailTypes,
  getAllSABanners,
  uploadSABanner,
  updateSABanner,
  deleteCMSLanguage,
  updateReorderGames,
  // getTenantLanguages,
  addInternalTag,
  getLanguageSupportKeys,
  uploadLanguageCSV,
  updateLanguageSupport,
  getCMSLanguage,
  getElasticHealth,
  sendMail,
  resetPassword,
  updateUserAffiliate,
  addUserAffiliate,
  updateKycMethod,
  getPaymentAggregators,
  getPaymentProvider,
  getProviderDetails,
  configProviderSettings,
  updatePaymentProviderStatus,
  reOrderPaymentProviders,
  getCommentsList,
  addComments,
  updateSAUserStatus,
  updateComment,
  reorderBonus,
  getSegments,
  deleteBonus,
  verifyPlayerEmail,
  resetProfilePassword,
  resetPasswordEmail,
  resetUserPassword,
  getPaymentCategories,
  orderPaymentCategories,
  updateUser,
  getCashbackData,
  getAdminConfiguration,
  createAdminConfiguration,
  updateAdminConfiguration,
  updateSiteConfiguration,
  getSiteConfiguration,
  getSuperAdminSportsTransactions,
  deleteTenantAdminCasinoProvider,
  deleteTenantAdminCasinoGames,
  updateCasinoSubCategory,
  updateCasinoCategory,
  createCasinoCategory,
  createCasinoSubCategory,
  deleteSABanners,
  deleteEmailTemplate,
  getBetSettings,
  updateBetSettings,
  addBetSettings,
  getSportsList,
  getCountriesList,
  getMatchesList,
  getMarketsList,
  getTournamentsList,
  updateStatus,
  sendEmailTemplate,
  createPromotions,
  getAllPromotions,
  depositCasino,
  getWelcomeBonus,
  updateWelcomeBonus,
  getAffiliateRequests,
  updateAffiliateStatus,
  getRefferedUsers,
  getPlayerGameReport,
  getAllNotifications,
  markNotificationRead,
  getUserStats,
  getBankingTransactions,
  updateTransactionStatus,
  getBankingDetails,
  createBankingDetails,
  updateBankingDetails,
  deleteBankingDetails,
  verifyOrMarkSuspiciousUser,
  getAllTransactionDrivers,
  createOrUpdateTransactionDriver,
  getTransactionDriversList,
  updateBankingDetailsStatus,
  updateCasinoGameThumbnailURL,
  createStaff,
  getAllStaff,
  updateStaff,
  getStaffDetails,
  getAllAdminGroups,
  getStaffById,
  deleteStaff,
  updateStaffStatus,
  verifyStaffCode,
  getAllPromoCodes,
  getActivePromoCodes,
  sendUserPromoCode,
  createOrUpdatePromoCode,
  deletePromoCode,
  getAllVoucherCodes,
  createVoucherCode,
  updateVoucherCode,
  deleteVoucherCode,
  deleteCMS,
  deleteCasinoCategory,
  deleteTransactionDriver,
  getAllApks,
  updateAllApks,
  deleteUser,
  restoreUser,
  updateCryptoTransactionStatus,
  addCasinoGameCategory,
  getCategoryGames,
  getCategoryGamesCount,
  deleteCagegoryGame
};
